(function () {
  /* Hotfix: stale Shopify HTML/CSS cache — load v2 styles + fix broken card photos */
  if (!document.querySelector('link[href*="buildconnect.v2"]')) {
    var cssLink = document.querySelector('link[href*="buildconnect.css"]');
    if (cssLink) {
      var v2 = document.createElement('link');
      v2.rel = 'stylesheet';
      v2.href = cssLink.href.replace('buildconnect.css', 'buildconnect.v2.css');
      document.head.appendChild(v2);
    }
  }
  var imgFix = {
    'photo-1589939705383-2816930545a9': 'photo-1600566752355-35792bedcfea',
    'photo-1600585154340-be6161a56a0': 'photo-1600880292203-757bb62b4baf'
  };
  document.querySelectorAll('.bc-card-img[style]').forEach(function (el) {
    var s = el.getAttribute('style') || '';
    Object.keys(imgFix).forEach(function (bad) {
      if (s.indexOf(bad) >= 0) s = s.split(bad).join(imgFix[bad]);
    });
    el.setAttribute('style', s);
  });

  /* Hotfix: load 180 demo pros + panels v3 when Shopify CDN serves stale assets */
  if (!window.__bcProsHotfixStarted) {
    window.__bcProsHotfixStarted = true;
    var coreScript = document.currentScript || document.querySelector('script[src*="bc-core.js"]');
    if (coreScript && coreScript.src) {
      var assetBase = coreScript.src.replace(/bc-core\.js(\?.*)?$/, '');
      if (!document.querySelector('link[href*="buildconnect.v2.css"]')) {
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = assetBase + 'buildconnect.v2.css';
        document.head.appendChild(css);
      }
      fetch(assetBase + 'buildconnect-pros.json')
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (data && data.length) window.BC_PROS = data;
          if (document.querySelector('script[src*="buildconnect-panels"]') || window.__bcPanelsV3Loaded) return;
          var s = document.createElement('script');
          s.src = assetBase + 'buildconnect-panels.v3.js';
          s.defer = true;
          document.body.appendChild(s);
        })
        .catch(function () {});
    }
  }

  var root = document.querySelector('[data-bc-root]');
  if (!root) return;

  function showToast(msg) {
    var t = root.querySelector('[data-bc-toast]');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(function () {
      t.hidden = true;
    }, 4200);
  }
  window.__bcShowToast = showToast;

  function norm(s) {
    return (s || '').toLowerCase().trim();
  }

  function filterServices(query, service) {
    var q = norm(query);
    var svc = norm(service);
    var cards = root.querySelectorAll('[data-bc-book-service]');
    var pros = root.querySelectorAll('[data-bc-pro-book]');
    cards.forEach(function (card) {
      var title = norm(card.getAttribute('data-bc-book-service'));
      var text = norm(card.textContent);
      var match =
        (!svc || title.indexOf(svc) >= 0) &&
        (!q || title.indexOf(q) >= 0 || text.indexOf(q) >= 0);
      card.classList.toggle('is-match', match && (!!q || !!svc));
      card.classList.toggle('is-dim', (!!q || !!svc) && !match);
    });
    pros.forEach(function (pro) {
      var spec = norm(pro.getAttribute('data-bc-pro-book'));
      var row = pro.closest('.bc-pro');
      if (!row) return;
      var match =
        (!svc || spec.indexOf(svc) >= 0 || svc.indexOf(spec) >= 0) &&
        (!q || spec.indexOf(q) >= 0);
      row.classList.toggle('is-match', match && (!!q || !!svc));
      row.classList.toggle('is-dim', (!!q || !!svc) && !match);
    });
  }

  function bookService(name, zip) {
    var widget = root.querySelector('[data-bc-widget]');
    if (!widget) return;
    var sel = widget.querySelector('[data-bc-service]');
    var zipIn = widget.querySelector('[data-bc-zip]');
    if (sel && name) sel.value = name;
    if (zipIn && zip) zipIn.value = zip;
    widget.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function setMobileMenu(btn, nav, open) {
    nav.classList.toggle('is-open', open);
    nav.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    var menuIco = btn.querySelector('.bc-menu-ico');
    var closeIco = btn.querySelector('.bc-menu-ico-close');
    if (menuIco) menuIco.hidden = open;
    if (closeIco) closeIco.hidden = !open;
  }

  root.querySelectorAll('[data-bc-menu-btn]').forEach(function (btn) {
    var header = btn.closest('.bc-header');
    if (!header) return;
    var nav = header.querySelector('[data-bc-mobile-nav]');
    btn.addEventListener('click', function () {
      setMobileMenu(btn, nav, !nav.classList.contains('is-open'));
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        setMobileMenu(btn, nav, false);
      });
    });
  });

  function setDropdown(btn, open) {
    var dd = btn.parentElement.querySelector('[data-bc-dropdown]');
    if (!dd) return;
    dd.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  root.querySelectorAll('[data-bc-dd-btn]').forEach(function (btn) {
    var wrap = btn.closest('.bc-nav-dd-wrap');
    var dd = btn.parentElement.querySelector('[data-bc-dropdown]');
    if (!dd) return;
    dd.hidden = true;
    btn.setAttribute('aria-expanded', 'false');

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      setDropdown(btn, btn.getAttribute('aria-expanded') !== 'true');
    });

    if (wrap) {
      wrap.addEventListener('mouseenter', function () {
        setDropdown(btn, true);
      });
      wrap.addEventListener('mouseleave', function () {
        setDropdown(btn, false);
      });
    }

    document.addEventListener('click', function (e) {
      if (wrap && !wrap.contains(e.target)) setDropdown(btn, false);
    });

    dd.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        setDropdown(btn, false);
      });
    });
  });

  root.querySelectorAll('[data-bc-service-link]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (a.getAttribute('data-bc-open-panel')) return;
      e.preventDefault();
      var svc = a.getAttribute('data-bc-service-link');
      bookService(svc);
      filterServices('', svc);
      showToast('Showing ' + svc + ' services — book a pro on the right.');
      root.querySelector('[id^="bc-services"]')?.scrollIntoView({ behavior: 'smooth' });
    });
  });

  root.querySelectorAll('[data-bc-book-service]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (el.getAttribute('data-bc-open-panel')) return;
      e.preventDefault();
      bookService(el.getAttribute('data-bc-book-service'));
      showToast(
        'Ready to book ' +
          el.getAttribute('data-bc-book-service') +
          '. Enter zip and tap Find Pros.'
      );
    });
  });

  root.querySelectorAll('[data-bc-pro-book]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var spec = el.getAttribute('data-bc-pro-book');
      bookService(spec);
      el.closest('.bc-pro')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      showToast(
        'Opening profile for ' + spec + ' pro — complete booking to confirm.'
      );
    });
  });

  root.querySelectorAll('[data-bc-search-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var filter = form.querySelector('[data-bc-service-filter]');
      var input = form.querySelector('[data-bc-search-input]');
      var svc = filter ? filter.value : '';
      var q = input ? input.value.trim() : '';
      var hidden = form.querySelector('[data-bc-search-hidden]');
      if (hidden) hidden.value = q || svc;
      filterServices(q, svc);
      root.querySelector('[id^="bc-services"]')?.scrollIntoView({ behavior: 'smooth' });
      if (svc) bookService(svc);
      showToast(
        q || svc
          ? 'Found matching services for "' + (q || svc) + '".'
          : 'Browse all services below.'
      );
      history.replaceState(
        null,
        '',
        location.pathname +
          '?bcq=' +
          encodeURIComponent(q || svc) +
          (svc ? '&service=' + encodeURIComponent(svc) : '') +
          '#bc-services'
      );
    });
  });

  root.querySelectorAll('[data-bc-widget]').forEach(function (widget) {
    widget.querySelector('[data-bc-finish]')?.addEventListener('click', function () {
      var service = widget.querySelector('[data-bc-service]')?.value || 'Plumbing';
      var zip = widget.querySelector('[data-bc-zip]')?.value?.trim() || '10001';
      filterServices(service, service);
      root.querySelector('.bc-sidebar')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      showToast(
        '3 verified ' +
          service +
          ' pros available near ' +
          zip +
          '. Tap View Profile to connect.'
      );
      if (typeof window.bcTrackLead === 'function') {
        window.bcTrackLead('booking_widget', { service: service, zip: zip });
      }
      history.replaceState(
        null,
        '',
        location.pathname +
          '?service=' +
          encodeURIComponent(service) +
          '&zip=' +
          encodeURIComponent(zip) +
          '#bc-how'
      );
    });
  });

  (function handleQuery() {
    var p = new URLSearchParams(location.search);
    var q = p.get('bcq') || p.get('q') || '';
    var svc = p.get('service') || '';
    var zip = p.get('zip') || '';
    if (q || svc) {
      filterServices(q, svc);
      if (svc) bookService(svc, zip);
      if (location.hash.indexOf('bc-services') >= 0 || q || svc) {
        setTimeout(function () {
          root.querySelector('[id^="bc-services"]')?.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      }
    }
  })();

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!reduced && finePointer && !window.matchMedia('(max-width:960px)').matches) {
    root.querySelectorAll('[data-bc-hero]:not([data-bc-parallax-off])').forEach(function (hero) {
      var layers = hero.querySelectorAll('[data-depth]');
      var tilts = hero.querySelectorAll('.bc-tilt:not(.bc-widget)');
      var tx = 0,
        ty = 0,
        cx = 0,
        cy = 0;
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width - 0.5;
        ty = (e.clientY - r.top) / r.height - 0.5;
        parallaxActive = true;
        startParallax();
        tilts.forEach(function (el) {
          el.style.transform =
            'rotateX(' + -ty * 10 + 'deg) rotateY(' + tx * 12 + 'deg) translateZ(18px)';
        });
      });
      var parallaxActive = false;
      var parallaxRaf = null;
      function resetParallaxLayers() {
        layers.forEach(function (l) {
          l.style.transform = '';
        });
      }
      function parallaxLoop() {
        cx += (tx - cx) * 0.08;
        cy += (ty - cy) * 0.08;
        var moving =
          parallaxActive ||
          Math.abs(cx) > 0.002 ||
          Math.abs(cy) > 0.002 ||
          Math.abs(tx) > 0.002 ||
          Math.abs(ty) > 0.002;
        if (moving) {
          layers.forEach(function (l) {
            var d = parseFloat(l.getAttribute('data-depth') || '0.2');
            l.style.transform =
              'translate3d(' +
              cx * d * 90 +
              'px,' +
              cy * d * 70 +
              'px,0) scale(' +
              (1 + d * 0.04) +
              ')';
          });
          parallaxRaf = requestAnimationFrame(parallaxLoop);
        } else {
          parallaxRaf = null;
          resetParallaxLayers();
        }
      }
      function startParallax() {
        if (!parallaxRaf) parallaxRaf = requestAnimationFrame(parallaxLoop);
      }
      hero.addEventListener('mouseenter', function () {
        parallaxActive = true;
        startParallax();
      });
      hero.addEventListener('mouseleave', function () {
        parallaxActive = false;
        tx = 0;
        ty = 0;
        startParallax();
      });
    });
    root.querySelectorAll('.bc-card-3d').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform =
          'perspective(800px) rotateX(' +
          -y * 8 +
          'deg) rotateY(' +
          x * 10 +
          'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }
  root.querySelectorAll('.bc-reveal').forEach(function (el) {
    el.classList.add('bc-visible');
  });
})();
